import React from 'react';
import { withTheme, CircularProgress, withStyles } from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
import Img from 'react-image';
import PropTypes from 'prop-types';

const styles = () => ({
  fullImage: {
    height: '100%',
  },
});
const SingleStaticGraph = props => {
  const { classes, theme, staticGraph } = props;

  return (
    <Img
      src={staticGraph.url}
      alt={staticGraph.name}
      className={classes.fullImage}
      loader={<CircularProgress />}
      style={theme.palette.type === 'dark' ? { filter: 'invert(100%)' } : {}}
    />
  );
};

SingleStaticGraph.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  staticGraph: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTheme(SingleStaticGraph));
